// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"AM","cardInnerHeading":"AN","toggleWrapperClass":"AO","changeProfile":"AP AO","textWrapperClass":"AQ","toggleTextClass":"AR"};